var map = {
	".": 73016,
	"./": 73016,
	"./assets/images/instagram.webp": 83155,
	"./assets/images/youtube.webp": 76117,
	"./index": 73016,
	"./index.js": 73016,
	"./index.module.css": 62619
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 97079;